import { useState, useEffect } from "react";
import { toast } from "react-toastify";

import React from "react";

export default function EditableLabel({
  value,
  setValue,
  hasScallableWidth,
  type,
  disabled,
  autoFocus,
  onFocusValue
}) {
  const [editingValue, setEditingValue] = useState(value);
  const [width, setWidth] = useState(2);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    setEditingValue(isEditing ? onFocusValue : value);
  }, [value, onFocusValue, isEditing]);

  useEffect(() => {
    if (hasScallableWidth) {
      setWidth(String(value).length < 4 ? 4 : String(value).length);
    }
  }, [value]);

  useEffect(() => {
    if (autoFocus) {
      document.querySelector(`input[data-autofocus="true"]`)?.focus();
    }
  }, [autoFocus]);

  const onChange = (event) => {
    if (/^[0-9.]+$/.test(event.target.value) || event.target.value === "") {
      setEditingValue(event.target.value);
      // setWidth(event.target.value.length < 4 ? 4 : event.target.value.length);
    }
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter" || event.key === "Escape") {
      event.preventDefault();
      event.target.blur();
    }
  };

  const validateField = (target, type) => {
    let field = target.value;
    const warnInScreen = () => {
      target.offsetParent.classList.add("wrong-input");
      setTimeout(() => target.offsetParent.classList.remove("wrong-input"), 2200);
    };
    if (!field) {
      warnInScreen();
      throw new Error("Invalid value");
    }
    switch (type) {
      case "integer":
        if (Number(field) < 0) {
          warnInScreen();
          throw new Error("Invalid value");
        }
        break;
      case "percentage":
        const numValue = parseFloat(field);
        if (isNaN(numValue) || numValue < 0 || numValue > 100) {
          warnInScreen();
          throw new Error("Invalid value");
        }
        break;
      case "money":
        const formated = new Intl.NumberFormat("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(field);
        if (!formated) {
          warnInScreen();
          throw new Error("Invalid field");
        }
        break;
      default:
        throw new Error("Type not especified");
    }
  };

  const onFocus = () => {
    setIsEditing(true);
    setEditingValue(onFocusValue);
  };

  const onBlur = (event) => {
    setIsEditing(false);
    try {
      const value = event.target.value.trim();
      if (value === "") {
        setValue(type === "integer" ? "0" : "0.00");
        setWidth(4);
      } else {
        validateField(event.target, type);
        
        // Format display value based on type
        let displayValue = value;
        if (type === "percentage") {
          displayValue = parseFloat(value).toString() === "0" ? "0.00" : parseFloat(value).toString();
          setWidth(4);
        }
        
        setEditingValue(displayValue);
        setValue(displayValue);
      }
    } catch (err) {
      const defaultValue = type === "integer" ? "0" : "0.00";
      setEditingValue(defaultValue);
      toast.error(err.message);
    }
  };

  return (
    <input
      style={{
        height: "100%",
        minHeight: "1.5rem",
        cursor: "pointer",
        width: hasScallableWidth ? width + "ch" : "90%",
        border: "none",
        fontFamily: "'Noto Sans', sans-serif",
        backgroundColor: "transparent",
      }}
      type="text"
      size="number"
      value={editingValue}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      data-autofocus={autoFocus}
      autoFocus={autoFocus}
    />
  );
}
